import { Compass, Users, Folder } from 'lucide-react' // BrainCircuit, Settings, MessageCircle, Library, UserCircle, Newspaper, Handshake, Music
import type { LucideIcon } from 'lucide-react'

export interface NavigationItem {
  name: string;
  href: string;
  icon: LucideIcon;
  subtext?: string;
  subItems?: { to: string; label: string; icon?: LucideIcon }[];
  categoryKey?: 'explore' | 'projects' | 'friends';
}

// Simplified navigation structure - main items with potential sub-items
export const navigationItems = [
  {
    name: 'Explore',
    href: '/explore',
    icon: Compass,
    categoryKey: 'explore'
  } as NavigationItem,
  {
    name: 'Projects',
    href: '/projects',
    icon: Folder,
    categoryKey: 'projects',
    // subItems: [
    //   { to: '/workspace/default', label: 'Workspace', icon: GitBranch }
    // ]
  } as NavigationItem,
  {
    name: 'Friends',
    href: '/friends',
    icon: Users,
    categoryKey: 'friends',
    // subItems: [
    //   { to: '/collectives', label: 'Collectives', icon: CircleDot }
    // ]
  } as NavigationItem
] as NavigationItem[];

// Keep the old structure for backward compatibility
export const navigationGroups = [
  {
    name: 'Discovery',
    items: [
      { name: 'Explore', href: '/explore', icon: Compass } as NavigationItem,
    ]
  },
  {
    name: 'Workspace',
    items: [
      { name: 'Projects', href: '/projects', icon: Folder } as NavigationItem,
      // { name: 'Workspace', href: '/workspace/default', icon: LayoutDashboard } as NavigationItem,
    ]
  },
  {
    name: 'Network',
    items: [
      { name: 'Friends', href: '/friends', icon: Users } as NavigationItem,
      // { name: 'Collectives', href: '/collectives', icon: CircleDot } as NavigationItem,
    ]
  }
]

// Keep this for backward compatibility if needed elsewhere in the app
export const navigation = navigationGroups.flatMap(group => group.items) as NavigationItem[]

export const projectCategories = [
  'All',
  'Art',
  'Music',
  'Writing',
  'Film',
  'Photography',
  'Design',
  'Animation',
  'Game Development',
]

export const collectiveCategories = [
  'All',
  'Creative',
  'Technology',
  'Music',
  'Art',
  'Writing',
  'Film',
  'Gaming',
  'Education',
]

export const profileMenuItems = [
  { name: 'Your Profile', href: '/profile' },
  { name: 'Your Projects', href: '/projects' },
  { name: 'Your Commissions', href: '/my-commissions' },
  { name: 'Your Submissions', href: '/my-submissions' },
  { name: 'Pricing & Plans', href: '/pricing' },
  { name: 'Settings', href: '/settings' },
  { name: 'Sign out', href: '/auth/signout' },
] 